import useRecapLots from "../../hooks/useRecapLots";
import {Button, Col, Row, Select, Space, Spin, Table, Typography} from "antd";
import {columns} from "../../containers/RecapLot/columns";
import {CSVLink} from "react-csv";
import React, {useEffect, useRef, useState} from "react";
import CardAmount from "./CardAmount";
import usePdfGenerator from "../../hooks/usePdfGenerator";
import PdfReaderModal from "../modals/PdfReaderModal";

const {Title, Text} = Typography;

const LotRecapComponent = () => {

  // États pour l'année et le mois sélectionnés
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(0);
  const [tableHeight, setTableHeight] = useState(600);

  const {lots, years, number, loading: lotsLoading} = useRecapLots(selectedYear, selectedMonth);
  const {generatePdf, closeModal, pdfUrl, modalOpen, loading: pdfLoading} = usePdfGenerator();

  const containerRef = useRef();

  const handlePrint = async () => {
    const data = {
      year: selectedYear,
      month: selectedMonth,
      ca: lots.reduce((somme, element) => somme + element.total_ca, 0),
      honoraires: lots.reduce((somme, element) => somme + element.owner_fee, 0),
      other: lots.reduce((somme, element) => somme + element.agency_fee, 0),
      total: lots.reduce((somme, element) => somme + element.fees, 0),
      rented: lots.reduce((somme, element) => somme + element.rented, 0),
      number: lots.reduce((somme, element) => somme + element.number, 0),
    }

    try {
      await generatePdf('recap-lots-printing', data, 'POST');
    } catch (err) {
      alert('Erreur lors de la génération du PDF:', err);
    }
  };

  const handleYearChange = (value) => {
    setSelectedYear(parseInt(value));
  };

  const handleMonthChange = (value) => {
    setSelectedMonth(parseInt(value));
  };

  const updateTableHeight = () => {
    if (containerRef.current) {
      const windowHeight = window.innerHeight;
      const containerTop = containerRef.current.getBoundingClientRect().top;
      const footerHeight = 80; // Hauteur estimée pour le pied de page ou autres éléments

      // Calculer la hauteur disponible
      const availableHeight = windowHeight - containerTop - footerHeight;
      setTableHeight(availableHeight > 200 ? availableHeight : 200); // Minimum de 200px
    }
  };

  const months = [
    {value: 0, label: 'Complet'},
    {value: 1, label: 'Janvier'},
    {value: 2, label: 'Février'},
    {value: 3, label: 'Mars'},
    {value: 4, label: 'Avril'},
    {value: 5, label: 'Mai'},
    {value: 6, label: 'Juin'},
    {value: 7, label: 'Juillet'},
    {value: 8, label: 'Août'},
    {value: 9, label: 'Septembre'},
    {value: 10, label: 'Octobre'},
    {value: 11, label: 'Novembre'},
    {value: 12, label: 'Décembre'}
  ];

  useEffect(() => {
    // Mettre à jour la hauteur au chargement
    updateTableHeight();

    // Ajouter un écouteur d'événement pour le redimensionnement de la fenêtre
    window.addEventListener('resize', updateTableHeight);

    // Nettoyer l'écouteur lors du démontage du composant
    return () => window.removeEventListener('resize', updateTableHeight);
  }, []);

  return (
    <>
    <Spin
      size="large"
      tip="Chargement en cours..."
      spinning={lotsLoading}
      fullscreen={lotsLoading}
    />
      <div style={{padding: 10}}>
        <Row>
          <Space direction="vertical" size={0}>
            <Title style={{margin: 0, color: '#1E2A4A'}} level={2}>Récapitulatif C.A. par Lots</Title>
            <Text style={{fontSize: 16, fontStyle: "italic", color: "#4A4A4A"}}>{`Nombre de lot(s): ${number}`}</Text>
          </Space>
        </Row>
        <Row style={{textAlign: "right", marginBottom: 20}}>
          <Col span={24}>

            <Space wrap>
              <Select
                defaultValue={selectedYear}
                style={{textAlign: 'left', width: 120}}
                onChange={handleYearChange}
                options={years.map(year => ({value: year, label: year.toString()}))}
              />
              <Select
                defaultValue={selectedMonth}
                style={{textAlign: 'left', width: 120}}
                onChange={handleMonthChange}
                options={months.map(month => ({value: month.value, label: month.label}))}
              />

              <Button disabled={pdfLoading} onClick={handlePrint} className="btn-primary">Imprimer</Button>
              <Button>
                {number > 0 && (
                  <CSVLink
                    filename={"export.csv"}
                    data={lots}
                    // headers={headers()}
                    separator={";"}
                  >
                    Export CSV
                  </CSVLink>
                )}
              </Button>
            </Space>
          </Col>
        </Row>
        <Row gutter={[16, 16]} style={{textAlign: "right", marginBottom: 20}}>
          <CardAmount lots={lots}/>
        </Row>
      </div>
      <div style={{padding: 10}} ref={containerRef}>
        <Table
          className="list-data"
          dataSource={lots}
          columns={columns}
          pagination={false}
          scroll={{y: tableHeight}}
          rowKey="id"
        />
      </div>
      <PdfReaderModal
        open={modalOpen}
        onCancel={closeModal}
        pdfUrl={pdfUrl}
        title="Récapitulatif C.A. par Lots"
      />
    </>
  );
};

export default LotRecapComponent;